import { render } from "./Location.vue?vue&type=template&id=4afe9c61&scoped=true&bindings={\"isLoading\":\"data\",\"error\":\"data\",\"pins\":\"data\",\"text\":\"options\",\"images\":\"options\",\"loadCategories\":\"options\",\"handleError\":\"options\"}"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"

import "./Location.vue?vue&type=style&index=0&id=4afe9c61&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4afe9c61"

export default script